// extracted by mini-css-extract-plugin
module.exports = {"main":"arrow_main__ctVrq","content":"arrow_content__rBT_Q","arrowLeft":"arrow_arrowLeft__Tm3v4","arrowRight":"arrow_arrowRight__qvC_k"};